import { Vue } from "vue-property-decorator"

export default class FuelTypeModel extends Vue {
    constructor(gasoline: string, diesel: string, electricity: string, externallyChargeableGasolineHybrid: string, selfLoadingGasolineHybrid: string,
        externallyChargeableDieselHybrid: string, selfLoadingDieselHybrid: string, methaneCNG: string, gasolineCNG: string) {
        super()

        this.gasoline = gasoline
        this.diesel = diesel
        this.electricity = electricity
        this.externallyChargeableGasolineHybrid = externallyChargeableGasolineHybrid
        this.selfLoadingGasolineHybrid = selfLoadingGasolineHybrid
        this.externallyChargeableDieselHybrid = externallyChargeableDieselHybrid
        this.selfLoadingDieselHybrid = selfLoadingDieselHybrid
        this.methaneCNG = methaneCNG
        this.gasolineCNG = gasolineCNG
    }

    gasoline: string
    diesel: string
    electricity: string
    externallyChargeableGasolineHybrid: string
    selfLoadingGasolineHybrid: string
    externallyChargeableDieselHybrid: string
    selfLoadingDieselHybrid: string
    methaneCNG: string
    gasolineCNG: string

    ToStringArray() {
        return [this.gasoline, this.diesel, this.electricity, this.externallyChargeableGasolineHybrid, this.selfLoadingGasolineHybrid,
            this.externallyChargeableDieselHybrid, this.selfLoadingDieselHybrid, this.methaneCNG, this.gasolineCNG]
    }
}
